<template>
  <Modal v-on="$listeners">
    <template #container>
      <div :class="$style.root">
        <div :class="$style.arrow">
          <SvgIcon :size="160" :svg="require('!svg-inline-loader?classPrefix!@mdi/svg/svg/arrow-up-bold.svg')" />
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '../Modal'
import SvgIcon from '../SvgIcon'

export default {
  components: {
    Modal,
    SvgIcon,
  },
}
</script>

<style lang="scss" module>
.root {
  @apply w-full;
  @apply h-full;
  background-color: #fbe7be;
  @apply relative;
  @apply flex;
  @apply justify-center;
}

.arrow {
  color: #d78a4a;
  margin-top: 15rem;
  animation: floatUp 1.5s infinite;
}

@keyframes floatUp {
  0% {
    transform: translateY(0);
  }
  70% {
    transform: translateY(-10%);
  }
  100% {
    transform: translateY(0);
  }
}
</style>
